/*
 * /reflections (page)
 */
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { isAdmin } from "@psychology/utils"
import { createFileRoute } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { ReflectionQuestionsList } from "../../features/reflections/components/reflection-questions-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/reflections/")({
	component: ReflectionsPage,
	loader: authPageLoader,
})

function ReflectionsPage() {
	const { user } = Route.useLoaderData()

	const { data: questions, isLoading } =
		trpc.reflectionQuestion.getAllByFilter.useQuery({
			sort: { column: "createdAt", direction: "desc" },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Reflections"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"space-y-6"}>
					{isLoading ? (
						<div className={"space-y-4"}>
							{[1, 2, 3].map((i) => (
								<Skeleton key={i} className={"h-[120px] w-full rounded-lg"} />
							))}
						</div>
					) : (
						<ReflectionQuestionsList
							initialQuestions={questions ?? []}
							isAdmin={isAdmin(user)}
						/>
					)}
				</div>
			</Container>
		</Page>
	)
}
